import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_TRANSPORTATION_PROFILE_URL } from '../apiUrl';

const uploadMasterDataPreviewTransportationProfileApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_TRANSPORTATION_PROFILE_URL, data);
};

export default uploadMasterDataPreviewTransportationProfileApi;
